var StyleMode;
(function (StyleMode) {
    StyleMode["Regular"] = "regular";
    StyleMode["Outline"] = "outline";
})(StyleMode || (StyleMode = {}));
var ChipSelectionMode;
(function (ChipSelectionMode) {
    ChipSelectionMode["Single"] = "single";
    ChipSelectionMode["Multiple"] = "multiple";
})(ChipSelectionMode || (ChipSelectionMode = {}));
export { ChipSelectionMode, StyleMode, };
//# sourceMappingURL=chip.interface.js.map